import React from 'react';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WhatsApp_icon from '../../assets/img/WhatsApp_icon.png.webp';
const Contactus = () => {
  const phoneNumber = "+34617243659";
  const message = "Hello! I'm interested in your services.";
  const handleClick = () => {
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  }
  return (
    <>
      <div className='contactus'>
        <div className='row'>
          <div className='col-12'>
            <div className="d-flex align-items-center mb-3 heading_back_btn justify-content-between">
              <h5 className="m-0">Contact Us</h5>
              <button
                onClick={handleClick}
                className="btn btn-success rounded-3 ms-auto fw-semibold"
                style={{ fontSize: '0.95rem' }}
              >
                Chat with us
              </button>
            </div>
          </div>
          <div className='col-12'>
            <div className='number d-flex'>
              <PhoneAndroidIcon /> <h6>+34 617 24 36 59</h6>
            </div>
            <div className='email d-flex'>
              <MailOutlineIcon /> <h6>info@nanny-line.com</h6>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contactus
